import { requestApi } from './Api';

export const setupTwilioNumber = (navigate, params) =>
  requestApi({
    navigate,
    url: '/api/twilio/provision',
    params
  });
